/**
 * Our Advisors — toggle the rest of a bio inline after “Read more”.
 */

(function () {
    'use strict';

    const ROOT_SELECTOR = '[data-our-advisors]';
    const TOGGLE_SELECTOR = '[data-advisors-toggle]';

    function setExpanded(button, expanded) {
        const bio = button.closest('.bio');
        const restId = button.getAttribute('aria-controls');
        const rest = restId ? document.getElementById(restId) : null;
        const ellipsis = bio ? bio.querySelector('[data-advisors-ellipsis]') : null;

        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        if (rest) {
            rest.hidden = !expanded;
        }

        if (ellipsis) {
            ellipsis.hidden = expanded;
        }
    }

    function onToggleClick(event) {
        const button = event.currentTarget;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        setExpanded(button, !expanded);
    }

    function bindRoot(root) {
        if (!root || root.dataset.advisorsInit === '1') {
            return;
        }

        root.dataset.advisorsInit = '1';

        root.querySelectorAll(TOGGLE_SELECTOR).forEach((button) => {
            button.addEventListener('click', onToggleClick);
        });
    }

    function initOurAdvisors(container) {
        const root = container || document;
        root.querySelectorAll(ROOT_SELECTOR).forEach((block) => bindRoot(block));
    }

    function onPageReady(e) {
        const container = e?.detail?.container || document;
        if (container.querySelector(ROOT_SELECTOR)) {
            initOurAdvisors(container);
        }
    }

    if (document.body?.hasAttribute?.('data-barba')) {
        document.addEventListener('barba:pageReady', onPageReady);
    } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () =>
            onPageReady({ detail: { container: document } })
        );
    } else {
        onPageReady({ detail: { container: document } });
    }
})();
